import React from 'react';
import { injectIntl } from 'react-intl';

import ReactEcharts from 'components/HTMLElements/ReactECharts';
import ChartConfig from 'constants/ChartConfig';

const Chart = ( { data = {}, intl, chatActive, phoneActive } ) => {
  const area = {};
  const series = [
    intl.formatMessage( { id: "facebook" } ),
    intl.formatMessage( { id: "twitter" } ),
    intl.formatMessage( { id: "email" } ),
    intl.formatMessage( { id: "walkin" } ),
  ];
  if( phoneActive ) series.push( intl.formatMessage( { id: "phone" } ) )
  if( chatActive ) series.push( intl.formatMessage( { id: "chat" } ) )

  const seriesYResolved = [
    data['FACEBOOK'] ? data['FACEBOOK']['RESOLVED'] : 0,
    data['TWITTER'] ? data['TWITTER']['RESOLVED'] : 0,
    data['EMAIL'] ? data['EMAIL']['RESOLVED'] : 0,
    data['WALK_IN'] ? data['WALK_IN']['RESOLVED'] : 0,
  ]
  if( phoneActive ) seriesYResolved.push( data['PHONE'] ? data['PHONE']['RESOLVED'] : 0 )
  if( chatActive ) seriesYResolved.push( data['CHAT'] ? data['CHAT']['RESOLVED'] : 0 )

  const seriesYPending = [
    data['FACEBOOK'] ? data['FACEBOOK']['PENDING'] : 0,
    data['TWITTER'] ? data['TWITTER']['PENDING'] : 0,
    data['EMAIL'] ? data['EMAIL']['PENDING'] : 0,
    data['WALK_IN'] ? data['WALK_IN']['PENDING'] : 0,
  ]
  if( phoneActive ) seriesYPending.push( data['PHONE'] ? data['PHONE']['PENDING'] : 0 )
  if( chatActive ) seriesYPending.push( data['CHAT'] ? data['CHAT']['PENDING'] : 0 )

  area.options = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: [intl.formatMessage( { id: "resolved" } ), intl.formatMessage( { id: "pending" } )],
      textStyle: {
        color: ChartConfig.color.text
      }
    },
    toolbox: {
      show: false
    },
    calculable: true,
    xAxis: [
      {
        type: 'category',
        data: series,
        axisLabel: {
          textStyle: {
            color: ChartConfig.color.text
          }
        },
        splitLine: {
          lineStyle: {
            color: ChartConfig.color.splitLine
          }
        }
      }
    ],
    yAxis: [
      {
        axisLabel: {
          textStyle: {
            color: ChartConfig.color.text
          }
        },
        splitLine: {
          lineStyle: {
            color: ChartConfig.color.splitLine
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ChartConfig.color.splitArea
          }
        }
      }
    ],
    series: [
      {
        name: intl.formatMessage( { id: "resolved" } ),
        type: 'bar',
        data: seriesYResolved,
        itemStyle: {
          normal: {
            color: ChartConfig.color.info
          }
        },
        lineStyle: {
          normal: {
            color: ChartConfig.color.info
          }
        },
        areaStyle: {
          normal: {
            color: ChartConfig.color.info
          }
        },
        symbol: 'diamond'
      },
      {
        name: intl.formatMessage( { id: "pending" } ),
        type: 'bar',
        barCategoryGap: '35%',
        data: seriesYPending,
        itemStyle: {
          normal: {
            color: ChartConfig.color.success
          }
        },
        lineStyle: {
          normal: {
            color: ChartConfig.color.success
          }
        },
        areaStyle: {
          normal: {
            color: ChartConfig.color.success
          }
        },
        symbol: 'diamond'
      }
    ]
  };
  return (
    <ReactEcharts style={{ height: '300px' }} option={area.options} showLoading={false}/> );
};

module.exports = injectIntl( Chart );



// WEBPACK FOOTER //
// ./routes/app/components/Dashboard/KPIsChart.js